module.exports = __webpack_public_path__ + "img/latitud.1eebb528.png";